import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { TokenService } from './token.service';
@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private token = '';
  constructor(private http: HttpClient, private tokenService : TokenService) { }
  loadToken() {
    this.token = localStorage.getItem('token');
  }
  // Verification login et mdp serveur
  checkLogin (login, password) {
    // post thes details to API servers return user info is correct
    this.loadToken();
    const tok = localStorage.getItem('token');
    // alert(tok);
    const id_pers = 0;
    const httpHeaders = new HttpHeaders({
      'Content-Type' : 'application/json',
      'head_hex': '' + tok,
      'hid_hex': '' + id_pers,
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'head_hex': '' + tok,
        'hid_hex': '' + id_pers,
      }),
    };
    // console.log(httpOptions);
    return this.http.post ('/api/login', {
      login,
      password,
    }, httpOptions);
  }
  // Lancer deconnexion token dans seveur
  logout() {
    const id_pers = 0;
    this.tokenService.stopRefreshToken();
    return this.http.post ('/api/logout', {id_pers});
  }
  getUsers(identifiant: number, mdp: string) {
    let result : {} = null;

    let userList = [
      {
        "id" : 1245,
        "nom" : "Doe",
        "prenom" : "John",
        "password" : "ancv",
        "droit" : "1"
      },
      {
        "id" : 1246,
        "nom" : "Doe",
        "prenom" : "Janne",
        "password" : "ancv",
        "droit" : "2"
      },
      {
        "id" : 1247,
        "nom" : "Doe",
        "prenom" : "Baby",
        "password" : "ancv",
        "droit" : "3"
      },
      {
        "id" : 1248,
        "nom" : "Doe",
        "prenom" : "Johnny",
        "password" : "ancv",
        "droit" : "4"
      },
      {
        "id" : 1249,
        "nom" : "Doe",
        "prenom" : "Jannie",
        "password" : "ancv",
        "droit" : "5"
      },
    ];

    userList.forEach(item => {
      if(item.id === identifiant && item.password === mdp) {
        result = item;
      }
    });

    return result;
  }

  checkIsLogged(): boolean{
    if(localStorage.getItem("user") !== null) {
      return true;
    }

    return false;
  }
}
